<template>
<div>
    <v-navigation-drawer
        v-model="drawer"
        width="230"
        class="white elevation-0"
        :mobile-break-point="960"
        app>
        <Navigation></Navigation>
    </v-navigation-drawer>

    <v-app-bar app flat class="primary" v-if="$vuetify.breakpoint.smAndDown">
        <!-- BAR BUTTON -->
        <v-btn class="mr-0" icon @click.stop="drawer = !drawer" v-if="!drawer">
            <v-icon color="white" size="20px">fa-bars fa-fw</v-icon>
        </v-btn>
        <!-- TITLE -->
        <v-toolbar-title class="headline white--text font-weight-bold" >
			3 STEPS ONLINE WORLD
        </v-toolbar-title>
        <!-- SPACER -->
        <v-spacer></v-spacer>
        <v-avatar size="32px">
            <v-img :src="user.photo.url" v-if="user.photo != null"></v-img>
            <v-img src="@/assets/user-default.jpg" v-else></v-img>
        </v-avatar>
    </v-app-bar>

    <v-content>
        <div :class="($vuetify.breakpoint.smAndDown) ? 'pa-3' : 'pa-4'">
            <v-card flat max-width="950px" class="mx-auto transparent">
                <div class="d-flex justify-end align-center" v-if="$vuetify.breakpoint.mdAndUp">
                    <!-- <div>
                        <div class="body-2 font-weight-bold primary--text">
                            3 STEPS ONLINE WORLD
                        </div>
                        <div class="info--text text--darken-2 font-weight-light" v-if="centerLoaded">
                            {{center.name}} Center
                        </div>
                    </div> -->
                    
                    <div class="d-flex align-right">
                        <v-avatar size="34px">
                            <v-img :src="user.photo.url" v-if="user.photo != null"></v-img>
                            <v-img src="@/assets/user-default.jpg" v-else></v-img>
                        </v-avatar>

                        <div class="caption ml-2 text-right">
                            <div class="primary--text text--darken-3">
                                {{user.name}}
                            </div>
                            <div class="primary--text font-weight-medium mt-n1 text-center">
                                <span v-if="user.role.master">Master</span>
                                <span v-if="user.role.director">Director</span>
                                <span v-if="user.role.captain">Captain</span>
                                <span v-if="user.role.student">Student</span>
                                <span v-if="user.role.pending">Pending</span>
                            </div>
                        </div>
                        
                        <div>
                            <v-btn icon @click="signout">
                                <v-icon small color="accent">fa-sign-out-alt</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>
            </v-card>
		    <router-view></router-view>

            <div class="caption text-center mt-10">
                Copyright © 2020 Young Potential Development LLC. All rights reserved.
            </div>
        </div>
    </v-content>
</div>
</template>

<script>
import Navigation from '@/components/core/Navigation'
import Centers from '@/firebase/centers'

export default {
    data() {
        return {
            drawer: false,
            showMenuOut: false,
            centerLoaded: false,
            center: null
        }
    },
    components: {
        Navigation
    },
    watch: {
        drawer(val) {
            if (val === false) {
                this.showStatistics = false;
            }
        }
    },
    mounted() {
        if (this.$vuetify.breakpoint.mdAndUp) {
			this.drawer = true;
        }

        if (this.user.role.denied) {
            this.signout();
        }

        if (this.user.role.director || this.user.role.student) {
            this.getCenter();
        }
    },
    computed: {
        getColor() {
            if (this.$route.path == '/home')     return 'primary--text';
            if (this.$route.path == '/my-profile')     return 'bProfile--text';
            if (this.$route.path == '/my-team')     return 'bTeam--text';
            if (this.$route.path == '/articles')     return 'bArticles--text';
            if (this.$route.path == '/videos')     return 'bVideos--text';
            if (this.$route.path == '/my-group')     return 'bGroup--text';
            if (this.$route.path == '/awards')     return 'bAwards--text';

            if (this.$route.path == '/admin-users')     return 'bProfile--text';
            if (this.$route.path == '/admin-teams')     return 'bTeam--text';
            if (this.$route.path == '/admin-groups-center')     return 'bGroup--text';
            if (this.$route.path == '/admin-sessions')     return 'bSessions--text';

            if (this.$route.path == '/account')     return 'accent--text';
            return 'primary--text'
        }
    },
    methods: {
        signout() {
            this.$store.dispatch('setUser', null);
        },
        getCenter() {
            Centers.get(this.user.center)
                    .then(response => {
                        if (response.status === true) {
                            this.center = response.doc.data();
                            this.centerLoaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred, please try again later.'});
                        }
                    });
        }
    }
}
</script>

<style>
    .v-overlay--active:before {
        opacity: .8 !important;  
    }
    .ober {
        cursor: pointer;
    }
    .not-ober {
        cursor: default;
    }
</style>


